import { replace } from 'connected-react-router'
import { getPageLocation } from 'selectors/index'

export const applySort = ({ navigationState }) => (dispatch, getState) => {
  const location = getPageLocation(getState())

  dispatch(replace({ ...location, search: navigationState }))
}
